import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MyProfileService {
  private dataSource = new BehaviorSubject(null);
  currentData = this.dataSource.asObservable();

  getData(data: string) {
    this.dataSource.next(data);
  }
}
